import { useRouter } from "next/router";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { BlockText, Button, Heading } from "@nju/ui";

export function ConfirmPage() {
  const router = useRouter();

  return (
    <div className="flex items-center justify-center flex-col py-4">
      <Heading
        className="font-bold mb-6 from-tablet:mb-8"
        font="ttfirs"
        tone="neutral"
        variant="h2"
      >
        wysłaliśmy do Ciebie e-mail
      </Heading>
      <Icon height={90} name="email-send" tone="none" width={90} />
      <div className="mt-4 mb-6">
        <BlockText>Sprawdź swoją skrzynkę pocztową.</BlockText>
      </div>
      <div className="mb-3 from-tablet:mb-5">
        <Button
          onPress={() => {
            router.push(portalRoutes.index.get());
          }}
        >
          ok
        </Button>
      </div>
    </div>
  );
}
